import { Component, Input, Output, QueryList, ViewChild, EventEmitter } from '@angular/core';
import { MatExpansionPanel } from '@angular/material/expansion';
import { start } from 'repl';
import { TranslationPipe } from '../../../shared/pipes/translation.pipe';
import { CdkDragDrop } from '@angular/cdk/drag-drop';
@Component({
  selector: 'app-question-list',
  templateUrl: './question-list.component.html',
  styleUrls: ['./question-list.component.scss']
})
export class QuestionListComponent {
  @Input('questionList') questionList: { id?: Array<string>, data?: Array<any> } = {};
  @Input('openedQuestionId') openedQuestionId: string = null;
  @Output('expandQuestion') expandQuestion = new EventEmitter<string>();
  @Output('listOrderUpdate') listOrderUpdate = new EventEmitter<any>();

  



  drop(event: CdkDragDrop<string[]>) {

    let id = event.item.element.nativeElement.dataset.questionid;

    let curIndex;
    this.questionList.id.forEach((item, index) => {
      if (item == id)
        curIndex = index;
    })

    let tmpId = this.questionList.id[event.previousIndex]
    let tmpData = this.questionList.data[event.previousIndex]

    this.questionList.id[event.previousIndex] = this.questionList.id[event.currentIndex]
    this.questionList.data[event.previousIndex] = this.questionList.data[event.currentIndex]

    this.questionList.data[event.previousIndex].priority = event.previousIndex


    this.questionList.id[event.currentIndex] = tmpId;
    this.questionList.data[event.currentIndex] = tmpData;

    this.questionList.data[event.currentIndex].priority = event.currentIndex;

    console.log(this.questionList)
    this.listOrderUpdate.emit(this.questionList)
  }

  getOpenedQuestion(id): boolean {
    let val: boolean = false;

    if (id == this.openedQuestionId)
      val = true;
    else if (id == null || this.openedQuestionId == null)
      val = false;
    return val;
  }

}
